// extracted by mini-css-extract-plugin
export default {"deleteBackstory--content":"deleteBackstory_deleteBackstory--content__B+tnu","deleteBackstory--content-btnContainer":"deleteBackstory_deleteBackstory--content-btnContainer__JvRRd"};